<!-- Linea de concepto normal -->
<div class="flex-container" *ngIf="isIgicImport === false">
  <div class="two-column">
    <mat-form-field class="width80">
      <input matInput placeholder="Base" type="text" [(ngModel)]="item.unityAmount" value="line.unityAmount"
        (click)="toZero()" numberDecimalsDirective>
    </mat-form-field>
    <app-help key='Gastos25'></app-help>
  </div>
  <div class="two-column">
    <app-autocomplete-select [items]="taxes" [idField]="'id'" [displayField]="'name'" placeholder="Impuestos"
      (selectionChanged)="onSelectTax($event)" [classList]="'width80'">
    </app-autocomplete-select>
    <app-help key='Gastos26'></app-help>
  </div>

  <div class="width80 mb-3">
    <convfact-chips-component [chipsElements]="item.taxes" [container]="this" [changeFunction]="changeChips">
    </convfact-chips-component>
  </div>

  <ng-container *ngIf="isRent()">
    <app-select [(ngModel)]="item.contactPropertyUid"
      [config]="{ placeholder: 'Propiedades', options: contactPropertiesOptions }">
    </app-select>
  </ng-container>

  <div class="two-column" *ngIf="showExpenseAccount === true">
    <mat-form-field class="w-100">
      <input matInput [(ngModel)]="item.expenseAccount" name="item.expenseAccount" value="line.expenseAccount"
        placeholder="Cuenta contable" [matAutocomplete]="autoE" [formControl]="expenseCtrl">
      <mat-autocomplete #autoE="matAutocomplete" class="expense-account-mat-autocomplete"
        classList="expense-account-mat-autocomplete">
        <mat-option *ngFor="let account of filteredExpenses | async; trackBy: trackByIndex" [value]="account.number">
          <span>{{ account.number }} - {{ account.name }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <mat-checkbox [(ngModel)]="showExpenseAccount" (change)="onShowExpenseAccountChange($event)" class="w-100">
    Añadir cuenta contable
  </mat-checkbox>

  <!-- Clasificador de gastos (partida/subpartida/familia) por concepto - solo asociaciones/fundaciones -->
  <ng-container *appCompanyMode="'nonprofit'">
    <div class="two-column">
      <app-autocomplete-select [items]="clasificadorPartidas" [selectedItemId]="item.clasificadorPartida"
        (selectionChanged)="onClasificadorPartidaChange($event)" [idField]="'id'" [displayField]="'data'"
        placeholder="Partida" [classList]="'width80'">
      </app-autocomplete-select>
    </div>
    <div class="two-column" *ngIf="item.clasificadorPartida && showSubpartidaSelect">
      <app-autocomplete-select [items]="clasificadorSubpartidas" [selectedItemId]="item.clasificadorSubpartida"
        (selectionChanged)="onClasificadorSubpartidaChange($event)" [idField]="'id'" [displayField]="'data'"
        placeholder="Subpartida" [classList]="'width80'">
      </app-autocomplete-select>
    </div>
    <div class="two-column"
      *ngIf="item.clasificadorSubpartida && clasificadorFamilias?.length > 0 && showFamiliaSelect">
      <app-autocomplete-select [items]="clasificadorFamilias" [(selectedItemId)]="item.clasificadorFamilia"
        [idField]="'id'" [displayField]="'data'" placeholder="Familia" [classList]="'width80'">
      </app-autocomplete-select>
    </div>
  </ng-container>
</div>

<!-- IGIC Importación -->
<div class="flex-container" *ngIf="isIgicImport === true">
  <div class="two-column">
    <mat-form-field class="w-100">
      <input matInput placeholder="Valor en aduana" type="text" [(ngModel)]="item.customsValue"
        value="line.customsValue" numberDecimalsDirective>
    </mat-form-field>
  </div>
  <div class="two-column">
    <mat-form-field class="w-100">
      <mat-select placeholder="Impuesto" #t (selectionChange)="setTax(t.value, item)">
        <mat-option selected disabled>Impuestos</mat-option>
        <mat-option *ngFor="let tax of accountsAndTaxes.taxes; trackBy: trackByIndex" [value]="tax">
          {{ tax.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="width80 mb-3">
    <convfact-chips-component [chipsElements]="item.taxes" [container]="this" [changeFunction]="changeChips">
    </convfact-chips-component>
  </div>

</div>
